<div class="main-container">
    <div class="main-form" (click)="$event.stopPropagation()">
        <div class="dock-details">
            <span>Doca</span>
            <span>{{dockNumber}}</span>
        </div>

        <div class="planned-container">
            <span>Viagens planejadas</span>
            <button (click)="togglePlanning()">
                TIME-TABLE
            </button>
        </div>

        <div class="planned-info">
            <ng-container *ngIf="sharedMotoresTransmissaoTrip; else emptyPlan">
                <table>
                    <thead>
                        <tr>
                            <th>VIAGEM</th>
                            <th>PROCESSO</th>
                            <th>CHEGADA SLA</th>
                            <th>SAÍDA SLA</th>
                            <th>EXTRA</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{{sharedMotoresTransmissaoTrip?.trip}}</td>
                            <td>{{sharedMotoresTransmissaoTrip?.processDescription}}</td>
                            <td>{{sharedMotoresTransmissaoTrip?.arrivalTimeSLA}}</td>
                            <td>{{sharedMotoresTransmissaoTrip?.departureTimeSLA}}</td>
                            <td>{{sharedMotoresTransmissaoTrip?.extra}}</td>
                        </tr>
                    </tbody>
                </table>
            </ng-container>
            <ng-template #emptyPlan>
                <h2 class="empty-data">Nenhuma viagem encontrada</h2>
            </ng-template>
        </div>
        <button class="btn-save" (click)="shareTripData()">Salvar</button>
    </div>
</div>

<app-motores-transmissao-time-table *ngIf="timeTableIsVisible" [mode]="'selection'"
    (rowSelected)="handleTripSelection($event)"></app-motores-transmissao-time-table>